// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"a97c4f80","197":"f6603064"}[chunkId] + ".chunk.js";
};